import { useForm } from 'react-hook-form';
import { Input } from '@shadcn/components/ui/input';
import {
  Select,
  SelectItem,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from '@shadcn/components/ui/select';
import useQuery from '../../../helpers/JIFI/useQuery';

import { Button } from '@shadcn/components/ui/button';
import { Label } from '@shadcn/components/ui/label';
import { Card, CardContent, CardHeader } from '@shadcn/components/ui/card';
import { Checkbox } from "@shadcn/components/ui/checkbox";
import { useState, useEffect, useCallback } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import superagent from 'superagent';
import { backendUrl } from '@helpers/consts';
import { CommandSearch } from '../order-ticket/feedback';
import ProductVariantSelector from '../helpers/ProductVariantSelector';
import useProductData from '../orders/useProductData';
import SelectItemsModal from './SelectItemsModal';
import { Textarea } from '@shadcn/components/ui/textarea';
import { uploadFileS3Bucket } from '@utilities/uploadFileS3Bucket';
import moment from 'moment';

import WizardNav from '@pages/JIFI/orders/Wizard/WizardNav';
import PetSection from './components/PetSection';
import ImageUploader from '@components/ImageUploader';
import { Store, Truck } from 'lucide-react';


export const states = [
  { value: 'VIC', label: 'Victoria' },
  { value: 'NSW', label: 'New South Wales' },
  { value: 'QLD', label: 'Queensland' },
  { value: 'WA', label: 'Western Australia' },
  {
    value: 'SA',
    label: 'South Australia'
  },
  {
    value: 'ACT',
    label: 'Australian Capital Territory'
  },
  {
    value: 'NT',
    label: 'Northern Territory'
  },
  {
    value: 'TAS',
    label: 'Tasmania'
  }
  
];


const monogramTypes = {
  text: 'Text',
  pets: 'Pets'
};

export const fonts = {
  heritage: 'Heritage',
  'bold-new': 'Bold (new)', 
  bubble: 'Bubble',
  'retro-serif': 'Retro Serif',
  graphic: 'Graphic',
  'sans-serif': 'Sans Serif',
  block: 'Block',
  signature: 'Signature',
  retro: 'Retro',
  serif: 'Serif',
  decorative: 'Decorative',
  'love-letter': 'Love Letter',
  painted: 'Painted',
  college: 'College',
  script: 'Script',
  casual: 'Casual',
  wide: 'Wide',
  bold: 'Block Serif',
  cursive: 'Modern Script',
  modern: 'Modern Serif'
};

export const newColors = {
  Lavender: '#90759B',
  Lilac: '#DCC5DF',
  'Ballet-Pink': '#F1C9DE',
  'Rose-Pink': '#DC75A4',
  Grenaine: '#9E5360',
  'Blush-Pink': '#E77472',
  Magenta: '#B12D52',
  Maroon: '#731A29',
  Red: '#C92327',
  'Burnt-Orange': '#DC5527',
  Mango: '#EF7E2E',
  Rust: '#9B4827',
  Toffee: '#705037',
  Taupe: '#D3A289',
  'Butter-Yellow': '#FBF3BE',
  Yellow: '#E8B629',
  Lime: '#C6B937',
  Green: '#4A813C',
  'Forest-Green': '#034123',
  Mint: '#78AB93',
  'Ice-Blue': '#BEE3E9',
  Denim: '#75A6B3',
  'Ocean-Blue': '#3E8EA1',
  Blue: '#1466B2',
  Grey: '#95979E',
  'Slate-Grey': '#63727E',
  Black: '#000000',
  White: '#FFFFFF'
};

export const locations = {
  Top: 'Top',
  Side: 'Side', 
  Back: 'Back'
};


const priorities = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];


export const FAULT_REASONS = [
  { value: 'crack', label: 'Crack' },
  { value: 'zip', label: 'Zip' },
  { value: 'lock', label: 'Lock' },
  { value: 'unable_to_repair', label: 'Unable to Repair' },
  { value: 'stitching', label: 'Stitching' },
  { value: 'other', label: 'Other' }
];





const createWarrantyTicket = async (data) => {
  try {
    
    const response = await superagent
      .post(`${backendUrl}/warranty-tickets`)
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .send(data);

    if (response.status >= 200 && response.status < 300) {
      toast.success('Warranty ticket created successfully');
    } else {
      toast.error('Failed to create warranty ticket');
    }
  } catch (error) {
    toast.error(`Error: ${error.message}`);
  }
};

export default function WarrantyClaim({ initialOrder=undefined, isForm = false, onModalChange, isWizard = false }) {
  
  const [linkToOrder, setLinkToOrder] = useState(true);
  
  const showOldOrderCheckbox = !isForm && !isWizard;  
  const {
    register,
    handleSubmit,
    watch,
    setError,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    
    defaultValues: {
      customerName: '',
      batchCode: '',
      originalOrderDate: '',
      order: initialOrder,
      orderNumber: '',
      fulfilled: false,
      replacementSkus: [],
      selectedItems: [],
      monogramData: [],
      store: '',
      replacementIssuedDate: '',
      faultReason: '',
      customerRequest: '',
      hasOrder: !!initialOrder,
    }
  });

  


  const [loading, setLoading] = useState(false);

  const [selectedVariants, setSelectedVariants] = useState([]);
  const [isSelectModalOpen, setIsSelectModalOpen] = useState(false);
  
  const order = watch('order');
  const selectedItems = watch('selectedItems');

  const getVariant = useProductData();
  const [data] = useQuery({ url: `/product`, refresh: false });
  const products = data?.data;

  const [monogramData, setMonogramData] = useState([]);
  
  
  const [itemDeliveryOptions, setItemDeliveryOptions] = useState([]);

  const [retailStores] = useQuery({
    url: '/inventory/getRetailStore',
  });


  const [replacementSkus, setReplacementSkus] = useState([]);

  

  

  
  useEffect(() => {
    if (initialOrder) {
      setValue('customerName', initialOrder.customer?.first_name + ' ' + initialOrder.customer?.last_name);
      setValue('originalOrderDate', moment(initialOrder.createdAt).format('YYYY-MM-DD'));
      setValue('order', initialOrder);
      
      
      const itemsToSelect = initialOrder.line_items.map(item => ({
        _id: item._id,
        sku: item.sku,
        quantity: item.quantity,

        monogram: item.monogram,
        monogram_text: item.monogram_text,
        monogram_font: item.monogram_font,
        monogram_color: item.monogram_color,
        monogram_position: item.monogram_position,
        monogrammed_by: item.monogrammed_by,
        pet: item.pet
      }));
      setValue('selectedItems', itemsToSelect);
      
      
      const initialVariants = itemsToSelect.map(() => []);
      const initialMonogramData = itemsToSelect.map(() => []);
      const initialDeliveryOptions = itemsToSelect.map(() => ({
        toBeShipped: true,
        pickupLocation: null,
        dateNeededBy: null
      }));
      setSelectedVariants(initialVariants);
      setMonogramData(initialMonogramData);
      setItemDeliveryOptions(initialDeliveryOptions);
    }
  }, [initialOrder, setValue]);

  useEffect(() => {
    
    if (initialOrder === undefined && order?.line_items && linkToOrder) {
      setIsSelectModalOpen(true);
    }
  }, [order, linkToOrder]);

  const isPersonalizedSKU = (sku) => {
    return sku?.split('-')
      .filter((val) => val !== 'P' && val !== 'LE')
      .join('-') !== sku;
  };

  
  
  const handleMonogramDataChange = (itemIndex, replacementIndex, field, value) => {
    setMonogramData(prev => {
      const newData = [...prev];
      if (!newData[itemIndex]) {
        newData[itemIndex] = [];
      }
      if (!newData[itemIndex][replacementIndex]) {
        newData[itemIndex][replacementIndex] = {};
      }
      newData[itemIndex][replacementIndex][field] = typeof value === 'function' ? value(newData[itemIndex][replacementIndex][field]) : value;
      
      return newData;
    });
    
  };

  
  const handleVariantSelect = (itemIndex, replacementIndex, variant) => {
    

    setSelectedVariants(prev => {
      const newVariants = [...prev];
      if (!newVariants[itemIndex]) {
        newVariants[itemIndex] = [];
      }
      
      
      const variantCopy = variant ? {
        ...variant,
        _originalRef: variant, 
        _timestamp: Date.now() 
      } : null;
      
      newVariants[itemIndex][replacementIndex] = variantCopy;
      
      
      return newVariants;
    });

    if (variant) {
      clearErrors('replacementSkus');

      
      if (!isPersonalizedSKU(variant.sku)) {
        
        
        setMonogramData(prev => {
          const newData = [...prev];
          if (!newData[itemIndex]) {
            newData[itemIndex] = [];
          }
          newData[itemIndex][replacementIndex] = null;
          
          return newData;
        });
        
      } else {
        
        
        setMonogramData(prev => {
          const newData = [...prev];
          if (!newData[itemIndex]) {
            newData[itemIndex] = [];
          }
          
          // Kiểm tra trong callback để đảm bảo state mới nhất
          if (!newData[itemIndex][replacementIndex]) {
            
            const newMonogramData = {
              type: '',
              text: '',
              font: '',
              color: '',
              location: '',
              shadowColor: ''
            };
            newData[itemIndex][replacementIndex] = newMonogramData;
            
          } 
          
          
          return newData;
        });
        
      }
    } else {
      
      
      setMonogramData(prev => {
        const newData = [...prev];
        if (!newData[itemIndex]) {
          newData[itemIndex] = [];
        }
        newData[itemIndex][replacementIndex] = null;
        
        return newData;
      });
      
    }
  };

  const fetchOrderDetails = async (orderId) => {
    try {
      const response = await superagent
        .get(`${backendUrl}/orders/${orderId}`)
        .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
        .set('accept', 'json');
      
      
      return response.body;
    } catch (error) {
      console.error('Error fetching customer info:', error);
    }
  };

  const handleModalItemSelect = async (items) => {
    
    setValue('selectedItems', items);
    const orderDetails = await fetchOrderDetails(order._id);
    setValue('originalOrderDate', moment(orderDetails.orderCreated).format('YYYY-MM-DD'));
          setValue('customerName', orderDetails.customer?.first_name + ' ' + orderDetails.customer?.last_name);
    
    const initialVariants = items.map(() => []);
    const initialMonogramData = items.map(() => []);
    const initialDeliveryOptions = items.map(() => ({
      toBeShipped: true,
      pickupLocation: null,
      dateNeededBy: null
    }));
    setSelectedVariants(initialVariants);
    setMonogramData(initialMonogramData);
    setItemDeliveryOptions(initialDeliveryOptions);
    
    setIsSelectModalOpen(false);
  };

  const renderSelectedItems = () => {
    const handleRemoveItem = (index) => {
      const newSelectedItems = [...selectedItems];
      newSelectedItems.splice(index, 1);
      setValue('selectedItems', newSelectedItems);
      clearErrors('replacementSkus');
      
      
      const newSelectedVariants = [...selectedVariants];
      newSelectedVariants.splice(index, 1);
      setSelectedVariants(newSelectedVariants);
      
      const newMonogramData = [...monogramData];
      newMonogramData.splice(index, 1);
      setMonogramData(newMonogramData);
      
      // Xóa delivery options cho item này
      const newDeliveryOptions = [...itemDeliveryOptions];
      newDeliveryOptions.splice(index, 1);
      setItemDeliveryOptions(newDeliveryOptions);
    };

    
    const handleAddReplacement = (itemIndex) => {
      setSelectedVariants(prev => {
        const newVariants = [...prev];
    
        while (newVariants.length <= itemIndex) {
          newVariants.push([]);
        }
        if (!newVariants[itemIndex]) {
          newVariants[itemIndex] = [];
        }
        newVariants[itemIndex].push(null);
        return newVariants;
      });
      
      setMonogramData(prev => {
        const newData = [...prev];
        
        while (newData.length <= itemIndex) {
          newData.push([]);
        }
        if (!newData[itemIndex]) {
          newData[itemIndex] = [];
        }
        newData[itemIndex].push(null);
        return newData;
      });
    };

    
    const handleRemoveReplacement = (itemIndex, replacementIndex) => {
      setSelectedVariants(prev => {
        const newVariants = [...prev];
        if (newVariants[itemIndex]) {
          newVariants[itemIndex].splice(replacementIndex, 1);
        }
        return newVariants;
      });
      
      setMonogramData(prev => {
        const newData = [...prev];
        if (newData[itemIndex]) {
          newData[itemIndex].splice(replacementIndex, 1);
        }
        return newData;
      });
      clearErrors('replacementSkus');
    };

    
    const handleItemDeliveryChange = (itemIndex, field, value) => {
      setItemDeliveryOptions(prev => {
        const newOptions = [...prev];
        if (!newOptions[itemIndex]) {
          newOptions[itemIndex] = { toBeShipped: true, pickupLocation: null };
        }
        newOptions[itemIndex] = {
          ...newOptions[itemIndex],
          [field]: value
        };
        return newOptions;
      });
    };
  
    return (
      <div className="space-y-6">
        {selectedItems?.map((item, index) => (
          <div key={item._id || `item-${index}`} className="border rounded-lg overflow-hidden bg-white relative group">
            
            <button
              onClick={() => handleRemoveItem(index)}
              className="absolute top-3 right-3 p-2 rounded-full hover:bg-gray-100 transition-colors"
              title="Remove item"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                className="text-gray-500 hover:text-red-500 transition-colors"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
  
            <div className="bg-gray-50 p-4 border-b">
              <h3 className="font-medium">Warranty Item #{index + 1}</h3>
            </div>
            


      
            <div className="p-6">
              <div className="grid grid-cols-1 gap-8">
      
                <div className="flex flex-col h-full">
                  <Label className="text-sm text-gray-500 mb-3">Original Product</Label>
                  <div className="bg-white border rounded-lg p-4 flex-1">
                    <div className="flex flex-col h-full">
                      <div className="flex gap-4 mb-4">
                        <div className="w-24 h-24 flex-shrink-0">
                          <img 
                            src={getVariant(item.sku)?.image} 
                            alt="" 
                            className="w-full h-full object-contain"
                          />
                        </div>
                        <div>
                          <h4 className="font-medium mb-1">{getVariant(item.sku)?.name}</h4>
                          <p className="text-sm text-gray-600">SKU: {item.sku}</p>
                          <p className="text-sm text-gray-600 mt-1">Quantity: {item.quantity}</p>
                        </div>
                      </div>

                      
                      {isPersonalizedSKU(item.sku) && item.monogram && (
                        <div className="border-t mt-4 pt-4">
                          <h5 className="font-medium mb-2">Personalisation Details</h5>
                          <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-gray-600">
                            <p className="flex items-center"><span className="font-medium mr-2">Type:</span> {item.pet ? 'Pets' : 'Text'}</p>
                            <p className="flex items-center"><span className="font-medium mr-2">Text:</span> {item.monogram_text}</p>
                            <p className="flex items-center"><span className="font-medium mr-2">Font:</span> {fonts[item.monogram_font] || item.monogram_font}</p>
                            <p className="flex items-center"><span className="font-medium mr-2">Color:</span> {item.monogram_color}</p>
                            <p className="flex items-center"><span className="font-medium mr-2">Location:</span> {locations[item.monogram_position] || item.monogram_position}</p>
                            {item.monogrammed_by && (
                              <p className="flex items-center"><span className="font-medium mr-2">Monogrammed by:</span> {item.monogrammed_by}</p>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
  
                
                <div className="flex flex-col h-full">
                  <div className="flex items-center justify-between mb-3">
                    <Label className="text-sm text-gray-500">Replacement Products</Label>
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      onClick={() => handleAddReplacement(index)}
                      className="h-8 px-3 text-xs"
                    >
                      + Add Replacement
                    </Button>
                  </div>
                  
                  <div className="space-y-4 flex-1">
                    
                    {(selectedVariants[index] || []).map((replacement, replacementIndex) => (
                      <div 
                        key={`item-${index}-replacement-${replacementIndex}-${replacement?.sku || 'empty'}`} 
                        className="border rounded-lg p-4 bg-gray-50 relative"
                      >
                        
                        {(selectedVariants[index]?.length || 0) > 1 && (
                          <button
                            onClick={() => handleRemoveReplacement(index, replacementIndex)}
                            className="absolute top-2 right-2 p-1 rounded-full hover:bg-gray-200 transition-colors"
                            title="Remove replacement"
                          >
                            <svg 
                              xmlns="http://www.w3.org/2000/svg" 
                              width="16" 
                              height="16" 
                              viewBox="0 0 24 24" 
                              fill="none" 
                              stroke="currentColor" 
                              strokeWidth="2" 
                              strokeLinecap="round" 
                              strokeLinejoin="round" 
                              className="text-gray-500 hover:text-red-500 transition-colors"
                            >
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                          </button>
                        )}

                        <h5 className="font-medium mb-3 text-sm">Replacement #{replacementIndex + 1}</h5>
                        
                        <ProductVariantSelector
                          products={products}
                          setSelectedVariant={(variant) => handleVariantSelect(index, replacementIndex, variant)}
                          selectedVariant={replacement}
                          className="mb-4"
                        />
                        
                        <div className="bg-white border rounded-lg p-3">
                          {replacement ? (
                            <>
                              <div className="flex gap-3 mb-3">
                                <div className="w-16 h-16 flex-shrink-0">
                                  <img 
                                    src={replacement.image} 
                                    alt="" 
                                    className="w-full h-full object-contain"
                                  />
                                </div>
                                <div>
                                  <h6 className="font-medium mb-1 text-sm">{replacement.name}</h6>
                                  <p className="text-xs text-gray-600">SKU: {replacement.sku}</p>
                                </div>
                              </div>

                              {replacement && 
                                isPersonalizedSKU(replacement.sku) && (
                                <div className="border rounded-lg p-3 space-y-3 bg-gray-50">
                                  <h6 className="font-medium text-sm">Monogram Data</h6>
                                  
                                  
                                  <div className="space-y-3">
                                    {/* Monogram Type */}
                                    <div>
                                      <Label className="text-xs">Monogram Type</Label>
                                      <Select
                                        value={monogramData[index]?.[replacementIndex]?.type || ''}
                                        onValueChange={(value) => {
                                          
                                          handleMonogramDataChange(index, replacementIndex, 'type', value);
                                        }}
                                      >
                                        <SelectTrigger className="h-8">
                                          <SelectValue placeholder="Select type" />
                                        </SelectTrigger>
                                        <SelectContent className="max-h-[200px] overflow-y-auto z-[1500]">
                                          {Object.entries(monogramTypes).map(([value, label]) => (
                                            <SelectItem key={value} value={value}>
                                              {label}
                                            </SelectItem>
                                          ))}
                                        </SelectContent>
                                      </Select>
                                    </div>

                                    {monogramData[index]?.[replacementIndex]?.type === 'text' ? (
                                      <>
                                        {/* Text Input */}
                                        <div>
                                          <Label className="text-xs">Text</Label>
                                          <Input
                                            className="h-8"
                                            value={monogramData[index]?.[replacementIndex]?.text || ''}
                                            onChange={(e) => handleMonogramDataChange(index, replacementIndex, 'text', e.target.value)}
                                            placeholder="Enter monogram text"
                                          />
                                        </div>

                                        {/* Font Selection */}
                                        <div>
                                          <Label className="text-xs">Font</Label>
                                          <Select
                                            value={monogramData[index]?.[replacementIndex]?.font || ''}
                                            onValueChange={(value) => handleMonogramDataChange(index, replacementIndex, 'font', value)}
                                          >
                                            <SelectTrigger className="h-8">
                                              <SelectValue placeholder="Select font" />
                                            </SelectTrigger>
                                            <SelectContent className="max-h-[200px] overflow-y-auto z-[1500]">
                                              {Object.entries(fonts).map(([value, label]) => (
                                                <SelectItem key={value} value={value}>
                                                  {label}
                                                </SelectItem>
                                              ))}
                                            </SelectContent>
                                          </Select>
                                        </div>

                                        {/* Color Selection */}
                                        <div>
                                          <Label className="text-xs">Color</Label>
                                          <Select
                                            value={monogramData[index]?.[replacementIndex]?.color || ''}
                                            onValueChange={(value) => handleMonogramDataChange(index, replacementIndex, 'color', value)}
                                          >
                                            <SelectTrigger className="h-8">
                                              <SelectValue placeholder="Select color" />
                                            </SelectTrigger>
                                            <SelectContent className="max-h-[200px] overflow-y-auto z-[1500]">
                                              {Object.entries(newColors).map(([value, color]) => (
                                                <SelectItem key={value} value={value}>
                                                  <div className="flex items-center gap-2">
                                                    <div 
                                                      className="w-3 h-3 rounded-full" 
                                                      style={{ backgroundColor: color }}
                                                    />
                                                    <span className="text-xs">{value.replace(/-/g, ' ')}</span>
                                                  </div>
                                                </SelectItem>
                                              ))}
                                            </SelectContent>
                                          </Select>
                                        </div>

                                        
                                        {['block', 'college', 'heritage', 'decorative'].includes(monogramData[index]?.[replacementIndex]?.font) && (
                                          <div>
                                            <Label className="text-xs">Shadow Color</Label>
                                            <Select
                                              value={monogramData[index]?.[replacementIndex]?.shadowColor || ''}
                                              onValueChange={(value) => handleMonogramDataChange(index, replacementIndex, 'shadowColor', value)}
                                            >
                                              <SelectTrigger className="h-8">
                                                <SelectValue placeholder="Select shadow color" />
                                              </SelectTrigger>
                                              <SelectContent className="max-h-[200px] overflow-y-auto z-[1500]">
                                                {Object.entries(newColors).map(([value, color]) => (
                                                  <SelectItem key={value} value={value}>
                                                    <div className="flex items-center gap-2">
                                                      <div 
                                                        className="w-3 h-3 rounded-full" 
                                                        style={{ backgroundColor: color }}
                                                      />
                                                      <span className="text-xs">{value.replace(/-/g, ' ')}</span>
                                                    </div>
                                                  </SelectItem>
                                                ))}
                                              </SelectContent>
                                            </Select>
                                          </div>
                                        )}

                                        
                                        <div>
                                          <Label className="text-xs">Location</Label>
                                          <Select
                                            value={monogramData[index]?.[replacementIndex]?.location || ''}
                                            onValueChange={(value) => handleMonogramDataChange(index, replacementIndex, 'location', value)}
                                          >
                                            <SelectTrigger className="h-8">
                                              <SelectValue placeholder="Select location" />
                                            </SelectTrigger>
                                            <SelectContent className="max-h-[200px] overflow-y-auto z-[1500]">
                                              {Object.entries(locations).map(([value, label]) => (
                                                <SelectItem key={value} value={value}>
                                                  {label}
                                                </SelectItem>
                                              ))}
                                            </SelectContent>
                                          </Select>
                                        </div>
                                      </>
                                    ) : monogramData[index]?.[replacementIndex]?.type === 'pets' && (
                                      <PetSection 
                                        key={`pet-section-${index}-${replacementIndex}`}
                                        index={`${index}-${replacementIndex}`}
                                        order={order}
                                        monogramData={monogramData[index]?.[replacementIndex] ? [monogramData[index][replacementIndex]] : []}
                                        onPetSelect={(data) => handlePetDataChange(`${index}-${replacementIndex}`, data)}
                                        onLocationChange={(location) => handleMonogramDataChange(index, replacementIndex, 'location', location)}
                                      />
                                    )}
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="h-16 flex items-center justify-center text-gray-400 text-sm">
                              No replacement product selected 
                            </div>
                          )}
                        </div>
                      </div>
                    ))}

                    
                    {(!selectedVariants[index] || selectedVariants[index].length === 0) && (
                      <div className="border-2 border-dashed border-gray-200 rounded-lg p-8 text-center">
                        <p className="text-gray-500 mb-3">No replacement products added yet</p>
                        <Button
                          type="button"
                          variant="outline"
                          onClick={() => handleAddReplacement(index)}
                          className="h-8 px-4 text-sm"
                        >
                          + Add First Replacement
                        </Button>
                      </div>
                    )}
                  </div>
                </div>

                
                <div className="flex flex-col h-full">
                  <Label className="text-sm text-gray-500 mb-3">Delivery Options</Label>
                  
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div
                      className={`p-3 rounded-lg border-2 cursor-pointer transition-all ${
                        !itemDeliveryOptions[index]?.toBeShipped 
                          ? 'border-primary bg-primary/5'
                          : 'border-gray-200 hover:border-gray-300'
                      }`}
                      onClick={() => {
                        handleItemDeliveryChange(index, 'toBeShipped', false);
                        handleItemDeliveryChange(index, 'pickupLocation', null);
                      }}
                    >
                      <div className="flex items-center gap-2">
                        <Store className="h-4 w-4 text-primary" />
                        <div>
                          <p className="font-medium text-sm">Store Pickup</p>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`p-3 rounded-lg border-2 cursor-pointer transition-all ${
                        itemDeliveryOptions[index]?.toBeShipped
                          ? 'border-primary bg-primary/5' 
                          : 'border-gray-200 hover:border-gray-300'
                      }`}
                      onClick={() => {
                        handleItemDeliveryChange(index, 'toBeShipped', true);
                        handleItemDeliveryChange(index, 'pickupLocation', null);
                      }}
                    >
                      <div className="flex items-center gap-2">
                        <Truck className="h-4 w-4 text-primary" />
                        <div>
                          <p className="font-medium text-sm">Ship to Customer</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  
                  {!itemDeliveryOptions[index]?.toBeShipped && (
                    <div>
                      <Label className="text-xs">Pickup Location*</Label>
                      <Select
                        value={itemDeliveryOptions[index]?.pickupLocation || ''}
                        onValueChange={(val) => handleItemDeliveryChange(index, 'pickupLocation', val)}
                      >
                        <SelectTrigger className="h-8">
                          <SelectValue placeholder="Select pickup location" />
                        </SelectTrigger>
                        <SelectContent className="max-h-[200px] overflow-y-auto z-[1500]">
                          {retailStores?.map((store) => (
                            <SelectItem key={store._id} value={store._id}>
                              {store.name}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                  )}

                  
                  {itemDeliveryOptions[index]?.toBeShipped && (
                    <div>
                      <Label className="text-xs">Date Needed By*</Label>
                      <Input
                        type="date"
                        className="h-8"
                        value={itemDeliveryOptions[index]?.dateNeededBy || ''}
                        onChange={(e) => handleItemDeliveryChange(index, 'dateNeededBy', e.target.value)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  
  
  
  const onSubmit = async (data) => {
    if (linkToOrder && !data.order) {
      setError('order', {
        type: 'manual',
        message: 'Order is required when not skipped'
      });
      return;
    }
    
    setLoading(true);
    
    
    let hasValidationError = false;
    
    if (linkToOrder) {
      for (let i = 0; i < data.selectedItems.length; i++) {
        const itemReplacements = selectedVariants[i] || [];
        const validReplacements = itemReplacements.filter(replacement => replacement !== null && replacement !== undefined);
        
        if (validReplacements.length === 0) {
          setError('replacementSkus', {
            type: 'manual',
            message: `Please select at least one replacement product for item #${i + 1}`,
          });
          hasValidationError = true;
          break;
        }
      }
    }
    
    if (hasValidationError) {
      setLoading(false);
      return;
    }
    try {
      if (data['files']) {
        for (const file of data['files']) {
          const fileUploaded = await uploadFileS3Bucket(
            file,
            `attachment_${Date.now()}`
          );
          data['attachments'] = [...(data['attachments'] || []), fileUploaded];
        }
      }
      
      

      delete data.uploadedImages
      
      let replacementSkusArray = [];
      
      if (linkToOrder) {
        for (let itemIndex = 0; itemIndex < data.selectedItems.length; itemIndex++) {
          const originalItem = data.selectedItems[itemIndex];
          const itemReplacements = selectedVariants[itemIndex] || [];
          
          
          const validReplacements = itemReplacements.filter(replacement => replacement !== null && replacement !== undefined);
          
          if (validReplacements.length > 0) {
          
            const replacementSkuString = validReplacements.map(replacement => replacement.sku).join(',');
            
          
            const monogramArray = validReplacements.map((replacement, replacementIndex) => {
              const actualReplacementIndex = itemReplacements.findIndex(r => r === replacement);
              const monogramDataForReplacement = monogramData[itemIndex]?.[actualReplacementIndex];
              
              if (!monogramDataForReplacement || !isPersonalizedSKU(replacement.sku)) {
                return null;
              }
              
              if (monogramDataForReplacement.type === 'pets') {
                return {
                  type: 'pets',
                  location: monogramDataForReplacement.location,
                  airtableLines: monogramDataForReplacement.airtableLines,
                  pets: monogramDataForReplacement.pets
                };
              }
              
              return {
                type: monogramDataForReplacement.type,
                text: monogramDataForReplacement.text,
                font: monogramDataForReplacement.font,
                color: monogramDataForReplacement.color,
                location: monogramDataForReplacement.location,
                shadowColor: ['block', 'college', 'heritage', 'decorative'].includes(monogramDataForReplacement.font) ? monogramDataForReplacement.shadowColor : undefined
              };
            });
            
            
            const replacementItem = {
              originalSku: originalItem.sku,
              replacementSku: replacementSkuString,
              monogram: monogramArray,
              toBeShipped: itemDeliveryOptions[itemIndex]?.toBeShipped !== false,
              pickupLocation: itemDeliveryOptions[itemIndex]?.pickupLocation || null,
              dateNeededBy: itemDeliveryOptions[itemIndex]?.dateNeededBy || null,
            };
            
            replacementSkusArray.push(replacementItem);
          }
        }
      }

      const formData = {
        ...data,
        selectedItems: data.selectedItems.map((item, index) => ({
          sku: item.sku,
          quantity: item.quantity.toString(),
        })),
        replacementSkus: linkToOrder ? replacementSkusArray : undefined,
      };
      
      
      
      if (!linkToOrder) {
        
        formData.replacementSkus = replacementSkus;
      }
      
      await createWarrantyTicket(formData);
    
      onModalChange?.(false);
    } catch (error) {
      console.error('Submission error:', error);
    } finally {
      setLoading(false);
    }
  };

  
  const onError = (errors) => {
    console.log("Form errors:", errors);
  
  };

  const handlePetDataChange = useCallback((index, petData) => {

    
    if (typeof index === 'string' && index.includes('-')) {
      const [itemIndex, replacementIndex] = index.split('-').map(Number);

      setMonogramData(prev => {
        const newData = [...prev];
        if (!newData[itemIndex]) {
          newData[itemIndex] = [];
        }
        if (!newData[itemIndex][replacementIndex]) {
          newData[itemIndex][replacementIndex] = {};
        }
        newData[itemIndex][replacementIndex] = {
          ...newData[itemIndex][replacementIndex],
          ...petData
        };
        
        return newData;
      });
      
    } else {
      
      setMonogramData(prev => {
        const newData = [...prev];
        if (!newData[index]) {
          newData[index] = {};
        }
        newData[index] = {
          ...newData[index],
          ...petData
        };
        
        return newData;
      });
      
    }
  }, []);

  
  



  

  

  return (
    <div>
      <div className={`${isForm ? '' : 'page-content'}`}>
        <div className={`${isForm ? '' : 'container mx-auto px-4 lg:max-w-[85%]'}`}>
          <Card className={`${isForm ? '' : 'max-w-lg mx-auto my-10 p-6'}`}>
            {!isForm && (
              <CardHeader className="text-2xl font-semibold">
                Retail Warranty Submission
              </CardHeader>
            )}
            {isWizard && <WizardNav steps={['Create Warranty Ticket']} activeTabProgress={1} />}
            <CardContent className={`${isForm ? 'pt-6' : ''}`}>
              <form onSubmit={handleSubmit(onSubmit, onError)} className="space-y-6">
               
                <div className="mb-4">
                  <Label htmlFor="retailMemberName">Retail Member Name*</Label>
                  <Input
                    id="retailMemberName"
                    {...register('retailMemberName', { required: true })}
                    placeholder="Enter your name"
                  />
                  {errors.retailMemberName && (
                    <p className="text-red-500">This field is required</p>
                  )}
                </div>

                {/* State */}
                <div className="mb-4">
                  <Label htmlFor="state">State*</Label>
                  <Select
                    onValueChange={(val) => setValue('state', val, {shouldValidate: true})}
                    {...register('state', { required: true })}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Select state" />
                    </SelectTrigger>
                    <SelectContent className="max-h-[200px] overflow-y-auto z-[1500]">
                      {states.map((state) => (
                        <SelectItem key={state.value} value={state.value}>
                          {state.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {errors.state && (
                    <p className="text-red-500">This field is required</p>
                  )}
                </div>

                {/* Order Selection comman*/}
                <div className="mb-4">
                  

                 
                  <Label htmlFor="order">Order #*</Label>
                  <CommandSearch 
                    orderName={initialOrder?.name} 
                    setValue={setValue}
                    linkToOrder={linkToOrder}
                  
                  />
                  {showOldOrderCheckbox &&
                  <div className="flex items-center space-x-2 my-2 mt-4">
                    <Checkbox
                      id="skipOrder"
                      checked={!linkToOrder}
                      onCheckedChange={(checked) => {
                        setLinkToOrder(!checked);
                        if (checked) {
                
                          setValue('order', null);
                          setValue('originalOrderDate', '');
                          setValue('selectedItems', []);
                          setValue('replacementSkus', []);
                          clearErrors('order');
                        }
                      }}
                    />
                    <Label className="mb-0" htmlFor="skipOrder">Old Order (Pre-2020)</Label>
                    </div>
}

                  {linkToOrder && errors.order && (
                    <p className="text-red-500 text-sm mt-1">This field is required</p>
                  )}


                </div>

                {(selectedItems.length > 0 ) && (
                  <div className="mb-4">
                    <Label>Selected Items for Warranty</Label>
                    {errors.replacementSkus && (
      <p className="text-red-500 mb-2">{errors.replacementSkus.message}</p>
    )}
                    {renderSelectedItems()}

                    
                  </div>
                )}


                {/* Original Order Date */}
                <div className="mb-4">
                  <Label htmlFor="originalOrderDate">Original Order Date</Label>
                  <Input
                    type="date"
                    id="originalOrderDate"
                    {...register('originalOrderDate')}
                  />
                </div>

                {/* Replacement Issued Date */}
                <div className="mb-4">
                  <Label htmlFor="replacementIssuedDate">Replacement Issued Date*</Label>
                  <Input
                    type="date"
                    id="replacementIssuedDate"
                    {...register('replacementIssuedDate', { required: 'This field is required' })}
                  />
                  {errors.replacementIssuedDate && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.replacementIssuedDate.message}
                    </p>
                  )}
                </div>

  
                <div className="mb-4">
                  <Label htmlFor="store">Store Location</Label>
                  <Select
                    onValueChange={(value) => setValue('store', value, {shouldValidate: true})}
                    value={watch('store')}
                    {...register('store', { required: true })}
                  >
                    <SelectTrigger className="w-full">
                      <SelectValue placeholder="Select store location" />
                    </SelectTrigger>
                    <SelectContent className="max-h-[200px] overflow-y-auto z-[1500]">
                      {retailStores?.map((store) => (
                        <SelectItem key={store._id} value={store._id}>
                          {store.name}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {errors.store && (
                    <p className="text-sm text-red-500 mt-1">
                      Please select a store location
                    </p>
                  )}
                </div>
                  {/* Customer Name */}
                <div className="mb-4">
                  <Label htmlFor="customerName">Customer Name*</Label>
                  <Input
                    id="customerName"
                    {...register('customerName', { required: true })}
                    placeholder="Enter customer name"
                  />
                  {errors.customerName && (
                    <p className="text-red-500">This field is required</p>
                  )}
                </div>

                
                <div className="mb-4">
                  <Label htmlFor="batchCode">Batch Code*</Label>
                  <Input
                    id="batchCode"
                    {...register('batchCode', { required: true })}
                    placeholder="Enter batch code"
                  />
                  {errors.batchCode && (
                    <p className="text-red-500">This field is required</p>
                  )}
                </div>

                {/* Priority */}
                <div className="mb-4">
                  <Label htmlFor="priority">Priority</Label>
                  <Select
                    onValueChange={(val) => setValue('priority', val)}
                    {...register('priority')}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Select priority" />
                    </SelectTrigger>
                    <SelectContent className="max-h-[200px] overflow-y-auto z-[1500]">
                      {priorities.map((priority) => (
                        <SelectItem key={priority.value} value={priority.value}>
                          {priority.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>

                {/* Add Modal */}
                <SelectItemsModal
                  isOpen={isSelectModalOpen}
                  onClose={() => setIsSelectModalOpen(false)}
                  orderItems={order?.line_items}
                  onConfirm={handleModalItemSelect}
                  getVariant={getVariant}
                />



              
                <div className="mb-4">
                  <Label htmlFor="faultReason">Fault / Reason for Submission*</Label>
                  <Select
                    onValueChange={(value) => setValue('faultReason', value)}
                    value={watch('faultReason')}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Select reason" />
                    </SelectTrigger>
                    <SelectContent className="max-h-[200px] overflow-y-auto z-[1500]">
                      {FAULT_REASONS.map((reason) => (
                        <SelectItem key={reason.value} value={reason.value}>
                          {reason.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {errors.faultReason && (
                    <p className="text-red-500">This field is required</p>
                  )}
                </div>

                <div className="space-y-4">
                      <div>
                        <Label className="text-sm font-medium mb-1 block">
                          Action Required - Customer Request*
                        </Label>
                        <Textarea
                          {...register('customerRequest', { required: 'This field is required' })}
                          className="min-h-[120px] focus-visible:ring-2 focus-visible:ring-blue-500"
                          placeholder="Describe customer's specific request..."
                        />
                        {errors.customerRequest && (
                          <p className="text-red-500 text-sm mt-1">
                            {errors.customerRequest.message}
                          </p>
                        )}
                      </div>

                    
                    </div>

                {/* Evidence Upload */}
                <div className="mb-4">
                  <Label htmlFor="files">Evidence for Warranty Submission*</Label>
                  <ImageUploader 
    value={watch('uploadedImages') || []}
    onChange={(imageList) => {
      setValue('uploadedImages', imageList);
      const files = imageList.map(image => image.file);
      setValue('files', files.length > 0 ? files : null);
      clearErrors('files');
    }}
    errorMessage={errors.files && "Please upload at least one image"}
  />
                  {errors.files && (
                    <p className="text-red-500">Evidence files are required</p>
                  )}
                </div>

                {/* Fulfilled */}
                <div className="mb-4">
                  <div className="flex items-center space-x-2">
                    <Checkbox
                      id="fulfilled"
                      checked={watch('fulfilled')}
                      onCheckedChange={(checked) => setValue('fulfilled', checked)}
                    />
                    <Label className="mb-0" htmlFor="fulfilled">Mark as Fulfilled</Label>
                  </div>
                </div>

            

                <div className="flex justify-end space-x-4">
                  <Button 
                    type="button" 
                    variant="outline" 
                    onClick={() => onModalChange?.(false)}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                  <Button 
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? 'Submitting...' : 'Submit Warranty Claim'}
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        toastClassName="border shadow-lg"
        progressStyle={{ backgroundColor: 'var(--primary)' }}
      />
    </div>
  );
}
